import { render } from "./page-main-section.vue?vue&type=template&id=77886394&scoped=true"
import script from "./page-main-section.vue?vue&type=script&lang=js"
export * from "./page-main-section.vue?vue&type=script&lang=js"

import "./page-main-section.vue?vue&type=style&index=0&id=77886394&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77886394"],['__file',"src/components/notepad/pages/page-main-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77886394"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77886394', __exports__)) {
    api.reload('77886394', __exports__)
  }
  
  module.hot.accept("./page-main-section.vue?vue&type=template&id=77886394&scoped=true", () => {
    api.rerender('77886394', render)
  })

}


export default __exports__